<template>
  <div class="tab_content tab__media" id="tab__media">
    <div class="image_upload__note vx-row items-center mx-2">
      <h3 class="mr-2">.jpg and .jpeg image accepted only</h3>
      <vs-button color="primary" @click="active = true" type="relief">Browse Stock Photos</vs-button>
    </div>

    <!-- drop zone -->
    <div class="mt-5 justify-center">
      <div id="dropzone" class="dropzone" ref="dropzone"></div>
    </div>
    <vs-popup id="stock-photo-popup" title="Stock Photo Gallery" :active.sync="active">
      <div class="vs-con-loading__container p-3" id="product-grid">
        <div class="grid gap-4">
          <div class="cursor-pointer pos-product" :key="index" v-for="(img, index) in stockPhotos">
            <img @click="selected(img)" :src="img.image_path" alt="latest-upload" class="rounded mb-4 user-latest-image w-full h-full responsive" />
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Dropzone from 'dropzone'
import { mapActions } from 'vuex'

import 'dropzone/dist/min/basic.min.css'
import 'dropzone/dist/min/dropzone.min.css'

export default {
  name: 'MediaTab',
  props: {
    form: {
      type: Object
    }
  },
  data() {
    const _vm = this
    return {
      dropzone: null,
      active: false,
      stockPhotos: [],
      dropzoneOptions: {
        s3: 'https://seedsuite.s3.us-east-2.amazonaws.com/',
        url: `${this.$http.defaults.baseURL}product/upload-image`,
        maxFiles: 2,
        paramName: 'files',
        acceptedFiles: 'image/jpg,image/jpeg',
        addRemoveLinks: true,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        async removedfile(file) {
          const f = _vm.form.product_images.findIndex((i) => file.name === i.file_name)
          if (file && file.id) {
            await _vm.removeImage(file.id)
          }
          if (f !== -1) {
            const product_images = _vm.form.product_images
            product_images.splice(f, 1)
            _vm.$emit('update:form', {
              ..._vm.form,
              product_images
            })
          }
          file.previewElement.parentNode.removeChild(file.previewElement)
        },
        init() {
          const drop = this
          drop.on('addedfile', _vm.added)
          drop.on('maxfilesexceeded', _vm.exceeded)
          for (const img of _vm.form.product_images) {
            const file = { name: img.file_name, size: 1234, manually: true, id: img.id }
            drop.emit('addedfile', file)
            drop.emit('thumbnail', file, img.url)
            drop.emit('complete', file)
          }
        },
        success(file, response) {
          if (_vm.form.product_images.length >= 2) {
            return
          }
          _vm.$emit('update:form', {
            ..._vm.form,
            product_images: [
              ..._vm.form.product_images,
              ...response.data.map((i) => ({
                file_name: i,
                name: file.name,
                url: _vm.dropzoneOptions.s3 + i
              }))
            ]
          })
        }
      }
    }
  },
  async mounted() {
    this.dropzone = new Dropzone(this.$refs.dropzone, this.dropzoneOptions)
    try {
      const { data } = await this.getStockPhotos({ page: 1, limit: 0 })
      this.stockPhotos = data
      // eslint-disable-next-line no-empty
    } catch ({ message }) {}
  },
  computed: {
    headers() {
      return { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    }
  },
  methods: {
    ...mapActions('setting', ['getStockPhotos']),
    ...mapActions('product', ['removeProductImageById']),
    exceeded(file) {
      this.dropzone.removeFile(file)
      this.$vs.notify({
        title: 'Error',
        text: `Can't upload files morethen ${this.dropzoneOptions.maxFiles}`,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    },
    added(file) {
      if (!file.manually && this.form.product_images.length >= 2) {
        this.$vs.notify({
          title: 'Error',
          text: `You can only upload  ${this.dropzoneOptions.maxFiles} images`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        file.previewElement.parentNode.removeChild(file.previewElement)
      }
    },
    async selected(img) {
      if (this.form.product_images.length < this.dropzoneOptions.maxFiles) {
        const file = { name: img.file_name, size: 12345, manually: true }
        this.dropzone.emit('addedfile', file)
        this.dropzone.emit('thumbnail', file, img.image_path)
        this.dropzone.emit('complete', file)

        this.active = false
        this.$emit('update:form', {
          ...this.form,
          product_images: [...this.form.product_images, { name: img.file_name, file_name: img.file_name, url: img.image_path, browsed: img }]
        })
      } else {
        this.$vs.notify({
          title: 'Error',
          text: `You can only upload  ${this.dropzoneOptions.maxFiles} images`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async removeImage(id) {
      try {
        const { message } = await this.removeProductImageById(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },

  async destroyed() {
    // this.dropzone.destroy()
    this.active = false
  }
}
</script>

<style lang="scss">
#tab__media {
  .dropzone-custom-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .dropzone-custom-title {
    margin-top: 0;
    color: #006622;
  }

  .dropzone .dz-preview .dz-image img {
    width: 120px;
    height: 120px;
  }
  .dropzone .dz-preview a:hover {
    background: none;
  }

  .user-latest-image {
    transition: all 0.2s ease-in-out;
    &:hover {
      transform: scale(1.2);
    }
  }
}

#stock-photo-popup {
  .border-green-500 {
    border-color: #006622;
  }
  .vs-popup {
    width: calc(100% - 50%) !important;
  }
  .grid {
    height: 100%;
    grid-auto-rows: 150px;
    overflow: auto;
    grid-template-columns: repeat(4, minmax(150px, 1fr)) !important;
    padding: 0 5px;

    img {
      object-fit: cover;
    }
  }
}
</style>
